// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateTextElementFontReducer extends Reducer
{
	public static reducerName: string = "UpdateTextElementFont";
	public static call(_elementId: number, _font: string) {
		this.getReducer().call(_elementId, _font);
	}

	public call(_elementId: number, _font: string) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _fontType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_fontType, _font);
		this.client.call("UpdateTextElementFont", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let fontType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let fontValue = AlgebraicValue.deserialize(fontType, adapter.next())
		let font = fontValue.asString();
		return [elementId, font];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _font: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _font: string) => void)
	{
		this.client.on("reducer:UpdateTextElementFont", callback);
	}
}


export default UpdateTextElementFontReducer
